import React from 'react';
import {__, _nonce} from '../../../../assets/javascripts/library.js';
import ReactDOM from 'react-dom/client';
import Overview from '../partials/overview.jsx';
import AllParticipants from '../partials/all-participants.jsx';
import LocalGroupParticipants from '../partials/localgroup-participants.jsx';
import ParticipationGroupParticipants from '../partials/participationgroup-participants.jsx';
import SignedOffParticipants from '../partials/signedoff-participants.jsx';
import { ToasterProvider } from "../../global-components/toaster.jsx";
import EventAddons from "../partials/event-addons.jsx";



function show_tab(tab, event_data) {
    var all_tabs = [
        'overview',
        'all_participants',
        'localgroup_participants',
        'participationgroup_participants',
        'signedoff_participants',
        'addons',
    ];

    for (var idx = 0; idx < all_tabs.length; idx++) {
        try {
            var currentElement = all_tabs[idx];
            document.getElementById('area_' + currentElement).classList.add('container_hidden');
            document.getElementById('area_' +currentElement).classList.remove('container_visible');
            document.getElementById('tab_' +currentElement).classList.remove('nav-tab-active');
        } catch {
            window.location.reload();
        }
    }

    document.getElementById('area_' + tab).classList.remove('container_hidden');
    document.getElementById('area_' + tab).classList.add('container_visible');
    document.getElementById('tab_' + tab).classList.add('nav-tab-active');


    const response = fetch("/wp-json/solea/event-details/print-page/" + tab, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: JSON.stringify({
            event_id: event_data.id,
            tab: tab,
            solea_nonce: _nonce(),

        }),
    })
        .then((res) => res.json())
        .then((data) => {

            var container = document.getElementById('area_' + tab);
            var root = ReactDOM.createRoot(container);

            switch (tab) {
                case 'overview':
                    window.location.reload();
                    break;
                case 'all_participants':
                    root.render(
                        <ToasterProvider>
                            <div id="solea_event_group_contents">
                                <AllParticipants link={tab} result={data.result} />
                            </div>
                        </ToasterProvider>
                    );
                    break;
                case 'localgroup_participants':
                    root.render(
                        <ToasterProvider>
                            <div id="solea_event_group_contents">
                                <LocalGroupParticipants link={tab} result={data.result} />
                            </div>
                        </ToasterProvider>
                    );
                    break;
                case 'participationgroup_participants':
                    root.render(
                        <ToasterProvider>
                            <div id="solea_event_group_contents">
                                <ParticipationGroupParticipants link={tab} result={data.result} />
                            </div>
                        </ToasterProvider>
                    );
                    break;
                case 'signedoff_participants':
                    root.render(
                        <ToasterProvider>
                            <div id="solea_event_group_contents">
                                <SignedOffParticipants link={tab} result={data.result} />
                            </div>
                        </ToasterProvider>
                    );
                    break;
                case 'addons':
                    root.render(
                        <ToasterProvider>
                            <div id="solea_event_group_contents">
                                <EventAddons link={tab} result={data.result} />
                            </div>
                        </ToasterProvider>
                        );
                    break;
            }
        }
    );
}



function NavigationBar({event_data}) {
    return (
        <div className="wrap" id="solea-navigation-bar">
                <ul className="nav-tab-wrapper">
                    <li id="tab_overview"
                        className="nav-tab nav-tab-active"
                        onClick={() => show_tab('overview', event_data)}
                    >
                        { __( 'Event overview', 'solea' ) }
                    </li>

                    <li id="tab_all_participants"
                        className="nav-tab"
                        onClick={() => show_tab('all_participants', event_data)}
                    >
                        { __( 'All participants', 'solea' ) }
                    </li>

                    <li id="tab_localgroup_participants"
                        className="nav-tab"
                        onClick={() => show_tab('localgroup_participants', event_data)}
                    >
                        { __( 'Participants by local group', 'solea' ) }
                    </li>

                    <li id="tab_participationgroup_participants"
                        className="nav-tab"
                        onClick={() => show_tab('participationgroup_participants', event_data)}
                    >
                        { __( 'Participants by participation group', 'solea' ) }
                    </li>

                    <li id="tab_signedoff_participants"
                        className="nav-tab"
                        onClick={() => show_tab('signedoff_participants', event_data)}
                    >
                        { __( 'Deregistered participants', 'solea' ) }
                    </li>

                    <li id="tab_addons"
                        className="nav-tab"
                        onClick={() => show_tab('addons', event_data)}
                    >
                        { __( 'Event addons', 'solea' ) }
                    </li>
                </ul>

        </div>

    );
}

export default NavigationBar;